import { Component, OnInit, AfterViewInit,Input, SimpleChanges } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from '../../../../core/auth/auth.service';
import { UserService } from '../../../../core/user.service';
import * as Chart from "chart.js";
import { bloomAdd } from '@angular/core/src/render3/di';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-cqmns-javaheap-utilization',
  templateUrl: './cqmns-javaheap-utilization.component.html',
  styleUrls: ['./cqmns-javaheap-utilization.component.css']
})
export class CqmnsJavaheapUtilizationComponent implements OnInit {

  @Input() serverId: any;
  projectId: any;
  hostUrl;
  ctxazureJavaheap: any;
  canvasazureJavaheap: any;
  JavaheapData: any;
  myChartazureJavaheap: any;
  intervalX;
  value1: any;
  fromTime: any;
  toTime: any;
  NowDate: any;
  isoDate: any;
  interval: any;
  serverIdAPI: any;
  showgraph: boolean;
  userId: string;

  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private userService: UserService,
    private toastr: ToastrService, private authService: AuthService, 
  ) {}

  ngOnInit() {
    this.authService.user() .subscribe(
      data => {});
    this.hostUrl = this.userService.getUrl();
    //this.projectId = this.route.snapshot.params["projectId"];
    this.userId = localStorage.getItem("userid");

    this.projectId = localStorage.getItem("projectId");
    this.value1 = "val01";
    // console.log(this.value1);
    // this.onchangeJavaheap(this.value1);
    // this.ngAfterViewInit();
  }
  ngOnChanges(changes:SimpleChanges){
        console.log(changes.serverId.currentValue);
        this.serverIdAPI = changes.serverId.currentValue;
        if(this.projectId){
        this.onchangeJavaheap(this.value1)

        // this.getJavaHeapDetails();
        this.ngAfterViewInit ();
        }
      } 
  getJavaHeapDetails()
  {
    var s = new Date();
    this.NowDate = new Date(s).toISOString().split('.')[0]+"Z";
    s.setMinutes(s.getMinutes() - 60);
    this.isoDate = new Date(s).toISOString().split('.')[0]+"Z";
      this.fromTime = this.NowDate;
      this.toTime = this.isoDate;
      this.interval = "PT1M"
      this.http
      .get(
        encodeURI(
          this.hostUrl +
            "/api/issue/azurejavaHeapDetails/" +
            this.projectId +
            "/" + this.serverIdAPI + '/' 

           + this.isoDate +
            "/" +
            this.NowDate +
            "/" +
            this.interval
        )
      )
      .subscribe(data => {
        this.JavaheapData = data;
        if (this.myChartazureJavaheap) {
        }
        this.updateChartJavaheap();
        this.updateChartAzureJavaHeap(this.myChartazureJavaheap);
        // let last: any = this.JavaheapData[this.JavaheapData.length - 2];
        // console.log(last.Average);
        // if (last.Average > 60) {
        //   this.toastr.warning("Memory utilization going up", "Warning ", {
        //     timeOut: 2000
   
        //    });
       //  }
       });
  }
  ngAfterViewInit() {
    this.updateChartJavaheap();
  }

  onchangeJavaheap(value1) {
    this.showgraph = true
    console.log(this.value1);
    this.value1 = value1;
    if (this.value1 === "val01") {
      var s = new Date();
      this.NowDate = new Date(s).toISOString().split(".")[0] + "Z";
      s.setMinutes(s.getMinutes() - 60);
      this.isoDate = new Date(s).toISOString().split(".")[0] + "Z";
      this.fromTime = this.NowDate;
      this.toTime = this.isoDate;
      this.interval = "PT1M";
    } else if (this.value1 === "val06") {
      var s = new Date();
      this.NowDate = new Date(s).toISOString().split(".")[0] + "Z";
      s.setMinutes(s.getMinutes() - 360);
      this.isoDate = new Date(s).toISOString().split(".")[0] + "Z";
      this.fromTime = this.NowDate;
      this.toTime = this.isoDate;
      this.interval = "PT1H";
    } else if (this.value1 === "val12") {
      var s = new Date();
      this.NowDate = new Date(s).toISOString().split(".")[0] + "Z";
      s.setMinutes(s.getMinutes() - 720);
      this.isoDate = new Date(s).toISOString().split(".")[0] + "Z";
      this.fromTime = this.NowDate;
      this.toTime = this.isoDate;
      this.interval = "PT1H";
    } else if (this.value1 === "val24") {
      var s = new Date();
      this.NowDate = new Date(s).toISOString().split(".")[0] + "Z";
      s.setMinutes(s.getMinutes() - 1440);
      this.isoDate = new Date(s).toISOString().split(".")[0] + "Z";
      this.fromTime = this.NowDate;
      this.toTime = this.isoDate;
      this.interval = "PT1H";
    }
    this.http
      .get(
        
        encodeURI(
          this.hostUrl +
            "/api/issue/azurejavaHeapDetails/" +
            this.projectId +
            "/" + this.serverIdAPI + '/' +
            this.isoDate +
            "/" +
            this.NowDate +
            "/" +
            this.interval
        )
      )
      .subscribe(data => {
        this.JavaheapData = data;
        if(this.JavaheapData.length === undefined){
          this.showgraph = false
          console.log(this.showgraph)

        } else {
          this.showgraph = true
          if (this.myChartazureJavaheap) {
          }
          this.updateChartJavaheap();
          this.updateChartAzureJavaHeap(this.myChartazureJavaheap);
        }
      
        
        
      });
    this.intervalX = setInterval(() => {
      this.intervalCall(this.isoDate);
    }, 60000);
  }
  intervalCall(isoDate) {
    this.NowDate = this.NowDate = new Date().toISOString().split(".")[0] + "Z";
    this.isoDate = isoDate;
    this.showgraph = true;
    this.http
      .get(
        encodeURI(
          this.hostUrl +
            "/api/issue/azurejavaHeapDetails/" +
            this.projectId +
            "/" + this.serverIdAPI + '/' +
            this.isoDate +
            "/" +
            this.NowDate +
            "/" +
            this.interval
        )
      )
      .subscribe(data => {
        this.JavaheapData = data;
       
        if(this.JavaheapData.length === undefined){
          this.showgraph = false
          console.log(this.showgraph)

        } else {
          this.showgraph = true
          if (this.myChartazureJavaheap) {
          }
          this.updateChartJavaheap();
          this.updateChartAzureJavaHeap(this.myChartazureJavaheap);
        }
      
        let last: any = this.JavaheapData[this.JavaheapData.length - 2];
        console.log(last.Average);
        // if (last.Average > 60) {
        //   this.toastr.warning("Memory utilization going up", "Warning ", {
        //     timeOut: 2000
        //   });
        // }
      });
  }
  timerUnSubscribe() {
    if (this.intervalX) {
      clearInterval(this.intervalX);
    }
  }
  public ngOnDestroy(): void {
    this.timerUnSubscribe();
  }
  updateChartJavaheap() {
    this.canvasazureJavaheap = document.getElementById("myChartazureJavaheap");
    this.ctxazureJavaheap = this.canvasazureJavaheap.getContext("2d");
    this.myChartazureJavaheap = new Chart(this.ctxazureJavaheap, {
      type: "line",
      data: {
        labels: [],
        datasets: [
          {
            data: [],
            label: "Average",
            borderColor: "#858585",
            borderWidth: 2,
            fill: true,
            lineTension: 0,
            borderJoinStyle: "miter",
            pointRadius: 2,
            backgroundColor: "rgba(40, 40, 40, 0.2)"
          }
        ]
      },
      options: {
        title: {
          display: true,
          text: "Java Heap",
          fontColor: "#5f7388",
          fontSize: 15
        },
        responsive: true, // for chart resize after update issue
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                display: false
              },
              scaleLabel: {
                display: true,
                labelString: "Time",
                fontFamily: "verdana",
                fontSize: 12
              },
              ticks: {
                autoSkip: true,
                maxTicksLimit: 6,
                stepSize: 0.2
              },
              // autoSkip: false,
              display: true
            }
          ],
          yAxes: [
            {
              gridLines: {
                display: true
              },
              scaleLabel: {
                display: true,
                labelString: "Percentage",
                fontFamily: "verdana",
                fontSize: 12
              },
              ticks: {
                beginAtZero: true
              }
            }
          ]
        }
      }
    });
  }
  updateChartAzureJavaHeap(myTrendsum) {
    for (let i = 0; i < this.JavaheapData.length; i++) {
      myTrendsum.data.labels.push(this.JavaheapData[i].Time);
      myTrendsum.data.datasets[0].data.push(this.JavaheapData[i].Average);
    }
    myTrendsum.update();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/cqm-ns/cqm-ns-monitoring/cqmns-javaheap-utilization/cqmns-javaheap-utilization.component.ts